module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-nowrap px-4 pt-4 justify-content-between row mx-0 align-items-center"
  }, [_c('h3', {
    staticClass: "d-flex px-0 col-auto"
  }, [_vm._v(_vm._s(_vm.title))]), _c('AppSvgIcon', {
    staticClass: "col-auto ui_color__black ui_cursor__pointer px-0 py-0",
    attrs: {
      "template": _vm.$ui.IconSvgComponents.close,
      "color-mode": "stroke"
    },
    on: {
      "click": function($event) {
        return _vm.$ui.$modal.close('AddEditStudyPlace')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36616cc8","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/study/components/AddEditStudyPlaceHeader.vue
// module id = 8a5dc35593c07888ec1c
// module chunks = 29